module.exports = "/resources/assets/prod/ce7077b3f256dc6df14878fca58b0da6.svg";